import styled, { css } from "styled-components";
import { Link as ReactRouterDomLink } from "react-router-dom";

const focusVisibleCss = css`
  &:focus-visible {
    outline: 4px solid ${({ theme }) => theme.token.colorPrimaryBorder};
    outline-offset: 1px;
    transition:
      outline-offset 0s,
      outline 0s;
  }
`;

export const StyledLink = styled(ReactRouterDomLink)`
  border-radius: ${({ theme }) => `${theme.token.borderRadius}px`};

  ${({ to }) => to && focusVisibleCss}
`;
